export default {
    warnings: {
        straightRow: 'Le sequenze lineari dei tasti sulla tastiera sono facili da indovinare.',
        keyPattern: 'Le brevi combinazioni di tasti sono facili da indovinare.',
        simpleRepeat: 'I caratteri ripetuti come "aaa" sono facili da indovinare.',
        extendedRepeat: 'Le combinazioni di caratteri ripetuti come "abcabcabc" sono facili da indovinare.',
        sequences: 'Le sequenze di caratteri comuni come "abc" sono facili da indovinare.',
        recentYears: 'Gli anni recenti sono facili da indovinare.',
        dates: 'Le date sono facili da indovinare.',
        topTen: 'Questa è una password molto usata.',
        topHundred: 'Questa è una password usata spesso.',
        common: 'Questa è una password di uso comune.',
        similarToCommon: 'Questa assomiglia a una password di uso comune.',
        wordByItself: 'Le singole parole sono facili da indovinare.',
        namesByThemselves: 'I singoli nomi o cognomi sono facili da indovinare.',
        commonNames: 'I nomi e cognomi comuni sono facili da indovinare.',
        userInputs: 'Non devono essere presenti dati personali o relativi alla pagina.',
        pwned: 'La tua password è stata esposta da una violazione dei dati su Internet.',
    },
    suggestions: {
        l33t: 'Evita prevedibili sostituzioni di lettere come "@" per "a".',
        reverseWords: 'Evita di scrivere parole di uso comune al contrario.',
        allUppercase: 'Scrivi alcune lettere in maiuscolo, ma non tutte.',
        capitalization: "Scrivi la prima lettera e almeno un'altra in maiuscolo.",
        dates: 'Evita le date e gli anni associati alla tua persona.',
        recentYears: 'Evita gli anni recenti.',
        associatedYears: 'Evita gli anni associati alla tua persona.',
        sequences: 'Evita le sequenze di caratteri comuni.',
        repeated: 'Evita la ripetizione di parole e caratteri.',
        longerKeyboardPattern: 'Usa combinazioni di tasti più lunghe e cambia più volte la direzione di digitazione.',
        anotherWord: 'Aggiungi un maggior numero di parole meno comuni.',
        useWords: 'Usa più parole, ma evita frasi comuni.',
        noNeed: 'Puoi creare password complesse senza utilizzare simboli, numeri o lettere maiuscole.',
        pwned: 'Se usi questa password altrove, dovresti cambiarla.',
    },
    timeEstimation: {
        ltSecond: 'meno di un secondo',
        second: '{base} secondo',
        seconds: '{base} secondi',
        minute: '{base} minuto',
        minutes: '{base} minuti',
        hour: '{base} ora',
        hours: '{base} ore',
        day: '{base} giorno',
        days: '{base} giorni',
        month: '{base} mese',
        months: '{base} mesi',
        year: '{base} anno',
        years: '{base} anni',
        centuries: 'secoli',
    },
};
//# sourceMappingURL=translations.js.map